/**
 * Layout constants for consistent sizing and spacing across the application
 * 
 * SPACING UNITS: Values marked as "spacing units" use MUI's theme.spacing()
 * where 1 unit = 8px by default. Use these directly with sx prop (e.g., p: DRAWER_PADDING)
 * 
 * PIXEL VALUES: Values marked as "px" are used in CSS calculations or
 * where specific pixel sizes are required (e.g., calc(100% - ${NAVBAR_HEIGHT}px))
 */

// Navigation Bar (px - used in CSS calc)
export const NAVBAR_HEIGHT_DESKTOP = 64 // Desktop
export const NAVBAR_HEIGHT_MOBILE = 56 // Mobile (Material Design standard)

// Drawer (Sidebar)
export const DRAWER_WIDTH_DESKTOP = 450 // px - used in CSS calc
export const DRAWER_WIDTH_MOBILE_MAX = 400 // px - used in maxWidth
export const DRAWER_WIDTH_MOBILE_PERCENT = '85%' // percentage
export const DRAWER_PADDING = 2.5 // spacing units (20px)

// Content Area
export const CONTENT_PADDING = 3 // spacing units (24px)
export const CONTENT_INNER_PADDING = 2.5 // spacing units (20px)

// Form Elements
export const FORM_INPUT_WIDTH = 10 // spacing units (80px)

// Placeholder & Empty States
export const PLACEHOLDER_MIN_HEIGHT = 50 // spacing units (400px)
export const PLACEHOLDER_MAX_WIDTH = 75 // spacing units (600px)

// Error Management
export const ERROR_AUTO_DISMISS_TIME = 5000 // ms
export const ERROR_MAX_DISPLAY = 3 // count

// Section Spacing
export const SECTION_SPACING = 2.5 // spacing units (20px)
